/**
 * Transformer that is triggered when the form on a `building-info` page
 * has been completely filled by the user. It sends all requests to BE.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', () => {
    const formState = kasko.getFormState();
    const state = kasko.getState();

    if (state.route.state.url !== '/building-info') {
      return;
    }

    if (formState.insured_sum_hr && state.input.insured_sum_hr_is_empty) {
      kasko.dispatchEvent('set-state-input', {
        insured_sum_hr_is_empty: false,
      });
    }

    if (
      !formState.insured_sum_hr &&
      formState.risk_address_street &&
      formState.risk_address_postcode &&
      formState.risk_address_house_number
    ) {
      if (state.input.insured_sum_hr_is_empty) {
        return;
      }
      kasko.dispatchEvent('trigger-requests');
      kasko.dispatchEvent('set-state-input', {
        insured_sum_hr_is_empty: true,
      });
    }
  });
};
